import React, {
  useEffect,
  useState,
} from "react";

import {
  Modal,
  Button,
} from "react-bootstrap";

import {
  putCamion as modifCamion,
} from "../helpers/rutaCamiones";

import "animate.css";

const estadoInicial = {
  camion: "",
  patente: "",

  tipoUnidad: "CAMION",
  marca: "",
  modelo: "",
  anio: "",

  titular: "",
  cuitTitular: "",
  perteneceDanlu: "",

  chasis: "",
  motor: "",
  tipoCombustible: "NO_INFORMADO",
  capacidadCarga: "",
  categoriaInterna: "",

  telepaseActivo: false,
  telepaseNroTag: "",
  telepaseNroContratoCuenta: "",
  telepaseEstado: "NO_APLICA",
  telepaseObservaciones: "",

  telepeajePlusActivo: false,
  telepeajePlusNroTag: "",
  telepeajePlusNroContratoCuenta: "",
  telepeajePlusEstado: "NO_APLICA",
  telepeajePlusObservaciones: "",

  observaciones: "",
};

const ModalFormCamion = ({
  camion,
  handleClose,
  show,
}) => {
  const [formValues, setFormValues] =
    useState(estadoInicial);

  const [guardando, setGuardando] =
    useState(false);

  const [showSuccess, setShowSuccess] =
    useState(false);

  const [mensajeError, setMensajeError] =
    useState("");

  /* ======================================================
     CARGAR DATOS
  ====================================================== */

  useEffect(() => {
    if (!camion?._id) {
      return;
    }

    setMensajeError("");

    setFormValues({
      camion:
        camion.camion || "",

      patente:
        camion.patente || "",

      tipoUnidad:
        camion.tipoUnidad ||
        "CAMION",

      marca:
        camion.marca || "",

      modelo:
        camion.modelo || "",

      anio:
        camion.anio || "",

      titular:
        camion.titular || "",

      cuitTitular:
        camion.cuitTitular ||
        "",

      perteneceDanlu:
        camion.perteneceDanlu === true
          ? "SI"
          : camion.perteneceDanlu ===
            false
          ? "NO"
          : "",

      chasis:
        camion.chasis || "",

      motor:
        camion.motor || "",

      tipoCombustible:
        camion.tipoCombustible ||
        "NO_INFORMADO",

      capacidadCarga:
        camion.capacidadCarga ||
        "",

      categoriaInterna:
        camion.categoriaInterna ||
        "",

      telepaseActivo:
        camion.peajes?.telepase
          ?.activo === true,

      telepaseNroTag:
        camion.peajes?.telepase
          ?.nroTag || "",

      telepaseNroContratoCuenta:
        camion.peajes?.telepase
          ?.nroContratoCuenta ||
        "",

      telepaseEstado:
        camion.peajes?.telepase
          ?.estadoDispositivo ||
        "NO_APLICA",

      telepaseObservaciones:
        camion.peajes?.telepase
          ?.observaciones || "",

      telepeajePlusActivo:
        camion.peajes
          ?.telepeajePlus
          ?.activo === true,

      telepeajePlusNroTag:
        camion.peajes
          ?.telepeajePlus
          ?.nroTag || "",

      telepeajePlusNroContratoCuenta:
        camion.peajes
          ?.telepeajePlus
          ?.nroContratoCuenta ||
        "",

      telepeajePlusEstado:
        camion.peajes
          ?.telepeajePlus
          ?.estadoDispositivo ||
        "NO_APLICA",

      telepeajePlusObservaciones:
        camion.peajes
          ?.telepeajePlus
          ?.observaciones || "",

      observaciones:
        camion.observaciones ||
        "",
    });
  }, [camion]);

  const handleChange = (e) => {
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    setFormValues((prev) => ({
      ...prev,

      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  /* ======================================================
     PAYLOAD
  ====================================================== */

  const armarPayload = () => ({
    camion:
      formValues.camion.trim(),

    patente:
      formValues.patente
        .trim()
        .toUpperCase()
        .replace(/\s+/g, ""),

    tipoUnidad:
      formValues.tipoUnidad,

    marca:
      formValues.marca.trim(),

    modelo:
      formValues.modelo.trim(),

    anio:
      formValues.anio
        ? Number(formValues.anio)
        : null,

    titular:
      formValues.titular.trim(),

    cuitTitular:
      formValues.cuitTitular.trim(),

    perteneceDanlu:
      formValues.perteneceDanlu === ""
        ? null
        : formValues.perteneceDanlu ===
          "SI",

    chasis:
      formValues.chasis.trim(),

    motor:
      formValues.motor.trim(),

    tipoCombustible:
      formValues.tipoCombustible,

    capacidadCarga:
      formValues.capacidadCarga
        ? Number(
            formValues.capacidadCarga
          )
        : 0,

    categoriaInterna:
      formValues.categoriaInterna.trim(),

    peajes: {
      telepase: {
        activo:
          formValues.telepaseActivo,

        nroTag:
          formValues.telepaseNroTag.trim(),

        nroContratoCuenta:
          formValues.telepaseNroContratoCuenta.trim(),

        estadoDispositivo:
          formValues.telepaseActivo
            ? formValues.telepaseEstado === "NO_APLICA"
              ? "ACTIVO"
              : formValues.telepaseEstado
            : "NO_APLICA",

        observaciones:
          formValues.telepaseObservaciones.trim(),
      },

      telepeajePlus: {
        activo:
          formValues.telepeajePlusActivo,

        nroTag:
          formValues.telepeajePlusNroTag.trim(),

        nroContratoCuenta:
          formValues.telepeajePlusNroContratoCuenta.trim(),

        estadoDispositivo:
          formValues.telepeajePlusActivo
            ? formValues.telepeajePlusEstado === "NO_APLICA"
              ? "ACTIVO"
              : formValues.telepeajePlusEstado
            : "NO_APLICA",

        observaciones:
          formValues.telepeajePlusObservaciones.trim(),
      },
    },

    observaciones:
      formValues.observaciones.trim(),
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!camion?._id) {
      return;
    }

    setMensajeError("");

    try {
      setGuardando(true);

      const resp =
        await modifCamion(
          camion._id,
          armarPayload()
        );

      if (!resp?.ok) {
        setMensajeError(
          typeof resp?.error === "string"
            ? resp.error
            : resp?.error?.message ||
                "No se pudo actualizar el vehículo."
        );

        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        handleClose();
      }, 1200);
    } catch (error) {
      console.error(error);

      setMensajeError(
        "Error al actualizar el vehículo."
      );
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="xl"
        centered
        scrollable
      >
        <form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              Modificar vehículo
              {camion?.patente
                ? ` - ${camion.patente}`
                : ""}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>

            {/* GENERAL */}

            <h6>Datos generales</h6>

            <div className="form-row">
              <div className="form-group col-md-3">
                <label>Patente *</label>

                <input
                  type="text"
                  className="form-control"
                  name="patente"
                  required
                  value={
                    formValues.patente
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-3">
                <label>
                  Tipo de unidad
                </label>

                <select
                  className="form-control"
                  name="tipoUnidad"
                  value={
                    formValues.tipoUnidad
                  }
                  onChange={
                    handleChange
                  }
                >
                  <option value="CAMION">
                    Camión
                  </option>

                  <option value="CAMIONETA">
                    Camioneta
                  </option>

                  <option value="AUTO">
                    Auto
                  </option>

                  <option value="ACOPLADO">
                    Acoplado
                  </option>

                  <option value="SEMIRREMOLQUE">
                    Semirremolque
                  </option>

                  <option value="UTILITARIO">
                    Utilitario
                  </option>

                  <option value="OTRO">
                    Otro
                  </option>
                </select>
              </div>

              <div className="form-group col-md-6">
                <label>
                  Descripción *
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="camion"
                  required
                  value={
                    formValues.camion
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label>Marca</label>

                <input
                  type="text"
                  className="form-control"
                  name="marca"
                  value={
                    formValues.marca
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>Modelo</label>

                <input
                  type="text"
                  className="form-control"
                  name="modelo"
                  value={
                    formValues.modelo
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>Año</label>

                <input
                  type="number"
                  className="form-control"
                  name="anio"
                  value={
                    formValues.anio
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>
            </div>

            <hr />

            {/* TITULARIDAD */}

            <h6>Titularidad</h6>

            <div className="form-row">
              <div className="form-group col-md-5">
                <label>Titular</label>

                <input
                  type="text"
                  className="form-control"
                  name="titular"
                  value={
                    formValues.titular
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>
                  CUIT titular
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="cuitTitular"
                  value={
                    formValues.cuitTitular
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-3">
                <label>
                  ¿Pertenece a DANLU?
                </label>

                <select
                  className="form-control"
                  name="perteneceDanlu"
                  value={
                    formValues.perteneceDanlu
                  }
                  onChange={
                    handleChange
                  }
                >
                  <option value="">
                    Sin informar
                  </option>

                  <option value="SI">
                    Sí
                  </option>

                  <option value="NO">
                    No
                  </option>
                </select>
              </div>
            </div>

            <hr />

            {/* TÉCNICOS */}

            <h6>Datos técnicos</h6>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label>Chasis</label>

                <input
                  type="text"
                  className="form-control"
                  name="chasis"
                  value={
                    formValues.chasis
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>Motor</label>

                <input
                  type="text"
                  className="form-control"
                  name="motor"
                  value={
                    formValues.motor
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>Combustible</label>

                <select
                  className="form-control"
                  name="tipoCombustible"
                  value={
                    formValues.tipoCombustible
                  }
                  onChange={
                    handleChange
                  }
                >
                  <option value="NO_INFORMADO">
                    No informado
                  </option>

                  <option value="DIESEL">
                    Diésel
                  </option>

                  <option value="NAFTA">
                    Nafta
                  </option>

                  <option value="GNC">
                    GNC
                  </option>

                  <option value="ELECTRICO">
                    Eléctrico
                  </option>

                  <option value="HIBRIDO">
                    Híbrido
                  </option>

                  <option value="NO_APLICA">
                    No aplica
                  </option>

                  <option value="OTRO">
                    Otro
                  </option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-4">
                <label>
                  Capacidad carga (kg)
                </label>

                <input
                  type="number"
                  className="form-control"
                  name="capacidadCarga"
                  value={
                    formValues.capacidadCarga
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              <div className="form-group col-md-4">
                <label>
                  Categoría interna
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="categoriaInterna"
                  value={
                    formValues.categoriaInterna
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>
            </div>

            <hr />

            {/* PEAJES */}

            <h6>
              Adhesión a peajes
            </h6>

            <div className="card mb-3">
              <div className="card-body">

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="editTelepase"
                    name="telepaseActivo"
                    checked={
                      formValues.telepaseActivo
                    }
                    onChange={
                      handleChange
                    }
                  />

                  <label
                    className="form-check-label font-weight-bold"
                    htmlFor="editTelepase"
                  >
                    TELEPASE
                  </label>
                </div>

                {formValues.telepaseActivo && (
                  <div className="form-row">
                    <div className="form-group col-md-4">
                      <label>
                        N.º Tag / oblea
                      </label>

                      <input
                        className="form-control"
                        name="telepaseNroTag"
                        value={
                          formValues.telepaseNroTag
                        }
                        onChange={
                          handleChange
                        }
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>
                        Contrato / cuenta
                      </label>

                      <input
                        className="form-control"
                        name="telepaseNroContratoCuenta"
                        value={
                          formValues.telepaseNroContratoCuenta
                        }
                        onChange={
                          handleChange
                        }
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Estado</label>

                      <select
                        className="form-control"
                        name="telepaseEstado"
                        value={
                          formValues.telepaseEstado
                        }
                        onChange={
                          handleChange
                        }
                      >
                        <option value="ACTIVO">
                          Activo
                        </option>

                        <option value="INACTIVO">
                          Inactivo
                        </option>

                        <option value="EN_TRAMITE">
                          En trámite
                        </option>

                        <option value="SIN_DISPOSITIVO">
                          Sin dispositivo
                        </option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="card mb-3">
              <div className="card-body">

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="editTelepeajePlus"
                    name="telepeajePlusActivo"
                    checked={
                      formValues.telepeajePlusActivo
                    }
                    onChange={
                      handleChange
                    }
                  />

                  <label
                    className="form-check-label font-weight-bold"
                    htmlFor="editTelepeajePlus"
                  >
                    TELEPEAJE PLUS
                  </label>
                </div>

                {formValues.telepeajePlusActivo && (
                  <div className="form-row">
                    <div className="form-group col-md-4">
                      <label>
                        N.º Tag / oblea
                      </label>

                      <input
                        className="form-control"
                        name="telepeajePlusNroTag"
                        value={
                          formValues.telepeajePlusNroTag
                        }
                        onChange={
                          handleChange
                        }
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>
                        Contrato / cuenta
                      </label>

                      <input
                        className="form-control"
                        name="telepeajePlusNroContratoCuenta"
                        value={
                          formValues.telepeajePlusNroContratoCuenta
                        }
                        onChange={
                          handleChange
                        }
                      />
                    </div>

                    <div className="form-group col-md-4">
                      <label>Estado</label>

                      <select
                        className="form-control"
                        name="telepeajePlusEstado"
                        value={
                          formValues.telepeajePlusEstado
                        }
                        onChange={
                          handleChange
                        }
                      >
                        <option value="ACTIVO">
                          Activo
                        </option>

                        <option value="INACTIVO">
                          Inactivo
                        </option>

                        <option value="EN_TRAMITE">
                          En trámite
                        </option>

                        <option value="SIN_DISPOSITIVO">
                          Sin dispositivo
                        </option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="form-group">
              <label>
                Observaciones
              </label>

              <textarea
                rows="2"
                className="form-control"
                name="observaciones"
                value={
                  formValues.observaciones
                }
                onChange={
                  handleChange
                }
              />
            </div>

            {mensajeError && (
              <div className="alert alert-danger">
                {mensajeError}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={handleClose}
              disabled={guardando}
            >
              Cancelar
            </Button>

            <Button
              type="submit"
              variant="success"
              disabled={guardando}
            >
              {guardando
                ? "Guardando..."
                : "Guardar cambios"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div
            style={{
              fontSize: "3rem",
            }}
          >
            ✅
          </div>

          <h5 className="mt-2">
            Cambios guardados correctamente
          </h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalFormCamion;